<template lang="pug">
  v-row
    v-col(cols=12)
      .mb-2 Список организаций, которые подписаны на модуль
      v-skeleton-loader(
        v-if="loading.subscribers"
        type="list-item@3"
      )
      div(v-else)
        p.grey--text(v-if="!subscribers.length") На ваш модуль нет подписок
        v-card(
          v-for="sub in subscribers"
          :key="sub.id"
          outlined
          :to="{ name: 'ModuleViewSubscribersView', params: { subId: sub.id } }"
        ).mt-2
          v-card-text
            .d-flex.align-center
              v-icon mdi-city-variant-outline
              .ml-4
                strong {{ sub.organization.short_name }}
                .caption {{ sub.organization.contact_person }}
              v-spacer
              tooltip-wrap(
                v-if="sub.course_module_prior_record_exists"
                text="Есть активные соглашения на использование модуля"
              )
                v-icon(
                  color="success darken-2"
                ) mdi-check-all
</template>

<script>
export default {
  props: {
    // Instance Module.js
    moduleItem: { type: Object, required: true },
  },
  data: () => ({
    subscribers: [],
    loading: {
      subscribers: false,
    },
  }),
  created() {
    this.fetchSubscribers();
  },
  methods: {
    async fetchSubscribers() {
      this.loading.subscribers = true;
      const { items } = await this.$api.modules.subscribersIndex({
        'search[course_module_id]': this.moduleItem.id,
        expand: 'organization,course_module_prior_record_exists',
      });
      this.subscribers = items;
      this.loading.subscribers = false;
    },
  },
};
</script>
